// @flow

import React, { Component } from 'react';
import { Link }             from 'react-router-dom';
import './stylishDropdown.css';

class StylishDropdown extends Component {

  state = {
    id: 0
  }

  componentDidMount = () => {
    let id = Math.floor(Math.random() * 9999) + 1;
    this.setState({id: id});
  }

  _handleClickCallback = (item: any) => {
    this.props.changeCallback(item);
  }

  render() {
    const { items, label } = this.props;
    const { id } = this.state;

    return (
      <div className="stylish-dropdown">
        <div className="dropdown">
          <button className="btn btn-default dropdown-toggle" type="button" id={"dropdown-menu-" + id} data-toggle="dropdown">
            {label}
            <span className="caret"></span>
          </button>
          <ul className="dropdown-menu" role="menu" aria-labelledby={"dropdown-menu-" + id}>
            {items && items.map((item, index) => (
              <li role="presentation" key={index}><Link to={item.url} role="menuitem" onClick={this._handleClickCallback.bind(this, item)}>{item.text}</Link></li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default StylishDropdown;



// WEBPACK FOOTER //
// ./src/components/common/stylishDropdown/stylishDropdown.js